import {
    SET_ORDER_BY_ID,
    SET_CART_COUNT,
    SET_CART_ORDERS,
    SET_DELETE_CART_ORDER
} from "./OrderType";

const initialState = {
    orderByIdData: [],
    cartCount: 0,
    cartOrders: [],
    cartOrderDelete: false
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ORDER_BY_ID:
            return {
                ...state,
                orderByIdData: action.orderByIdData,
            };
        case SET_CART_COUNT:
            return {
                ...state,
                cartCount: action.cartCount,
            };
        case SET_CART_ORDERS:
            return {
                ...state,
                cartOrders: action.cartOrders,
            };
        case SET_DELETE_CART_ORDER:
            return {
                ...state,
                cartOrderDelete: action.cartOrderDelete,                
            }    
        default:
            return state;
    }
};

export default reducer;
